module.exports = __webpack_public_path__ + "img/title.e07cbc50.png";